module.exports = __webpack_public_path__ + "img/data-analysis-assistant-qr-clean.e5247dc0.png";